import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface SpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
    size = 'medium',
    color = '#1C1C34'
}) => {
    // Map size names to pixel values
    const sizeMap = {
        small: 24,
        medium: 40,
        large: 56
    };

    const pixelSize = sizeMap[size];

    return (
        <Box className="flex justify-center items-center">
            <CircularProgress
                size={pixelSize}
                sx={{
                    color: color,
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                    }
                }}
            />
        </Box>
    );
}; 